import { LimitOrderEdit } from './LimitOrderEdit';
export class CareOrderEdit extends LimitOrderEdit {
    constructor(data, orderType) {
        super(data, orderType);
    }
}
